import { z } from 'zod'
import { buildI18nMessage } from '~/shared/lib/i18nMessageHelper'
import {
  bankBikRequiredSchema,
  bankRsRequiredSchema,
  dateSchema,
  innRequiredSchema,
  kppRequiredSchema,
  ogrnRequiredSchema,
  okpoRequiredSchema,
  phoneScheme,
  priceRequiredScheme,
  stringRequiredScheme,
} from '~/shared/lib/schemas'
import { ApiModel } from './core'

export const attributeSchema = z.object({
  name: stringRequiredScheme,
  fullName: stringRequiredScheme,
  inn: innRequiredSchema,
  bank: stringRequiredScheme,
  kpp: kppRequiredSchema.optional(),
  ogrn: ogrnRequiredSchema,
  okpo: okpoRequiredSchema.optional(),
  phoneNumber: phoneScheme.optional(),
  email: z
    .string()
    .email(buildI18nMessage('validate.invalid email address'))
    .or(z.literal(''))
    .optional(),
  webSite: z
    .string()
    .url(buildI18nMessage('validate.invalid url'))
    .or(z.literal(''))
    .optional(),
  legalAddress: stringRequiredScheme,
  actualAddress: stringRequiredScheme,
  rs: bankRsRequiredSchema,
  ks: bankRsRequiredSchema,
  bik: bankBikRequiredSchema,
  directorPosition: stringRequiredScheme,
  directorFio: stringRequiredScheme,
  directorPositionInParentalCase: stringRequiredScheme,
  directorFioInParentalCase: stringRequiredScheme,
  directorBasisForSigningDocuments: stringRequiredScheme,
  withNds: z.boolean().optional().default(false),
  authorizedCapital: priceRequiredScheme,
})

export const schema = z
  .object({
    createdAt: dateSchema.optional(),
    updatedAt: dateSchema.optional(),
  })
  .merge(attributeSchema)

export type CarRentalAttributes = z.infer<typeof schema>

export class CarRental extends ApiModel<typeof schema> {
  static jsonApiType = 'car-rentals'

  static schema = schema

  getName(): string {
    return this.getAttribute('name')
  }

  getOption(): { id: UniqueId; label: string } {
    return {
      id: this.getApiId() as UniqueId,
      label: this.getName(),
    }
  }

  getWebSite(): string {
    return this.getAttribute('web_site')
  }

  static async fetchOptions() {
    const response = await CarRental.get(1)
    return response.getData().map((o) => o.getOption())
  }
}
